module.exports = __webpack_public_path__ + "media/application/images/svgs/cloud-50eed99357ff2ca3d825f86d8fbddf67.svg";